module.exports = __webpack_public_path__ + "img/9788932910635.958e2da4.jpg";